import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-subscribe',
  templateUrl: './language-subscribe.component.html',
  styleUrls: ['./language-subscribe.component.scss']
})
export class LanguageSubscribeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
